/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData model module.
 * @module model/EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData
 * @version 1.0
 */
class EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData {
    /**
     * Constructs a new <code>EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData</code>.
     * @alias module:model/EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData
     */
    constructor() { 
        
        EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData} The populated <code>EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData();

            if (data.hasOwnProperty('freenftNo')) {
                obj['freenftNo'] = ApiClient.convertToType(data['freenftNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}



/**
 * @member {Number} freenftNo
 */
EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData.prototype['freenftNo'] = undefined;

/**
 * @member {Number} accountNo
 */
EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData.prototype['email'] = undefined;

/**
 * @member {Number} nftUid
 */
EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData.prototype['nftUid'] = undefined;

/**
 * @member {Date} createdAt
 */
EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData.prototype['createdAt'] = undefined;






export default EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData;

